import useUserStore from "../states/user";
import { fetchWithOrganization } from "./organizationRequest";

function normalizeBaseUrl(url) {
	return String(url || "").trim().replace(/\/$/, "");
}


function getCalendarBaseUrl() {
    return normalizeBaseUrl(process.env.REACT_APP_CALENDAR_BASE_URL || "http://localhost:8087");
}

const CALENDAR_BASE_URL = getCalendarBaseUrl();

function buildCalendarUrl(path) {
    const baseUrl = CALENDAR_BASE_URL;
    const normalizedPath = String(path || "").trim().replace(/^\//, "");
	return `${baseUrl}/calendar/${normalizedPath}`;
}

export async function requestJson(path, options = {}) {
	const response = await fetchWithOrganization(buildCalendarUrl(path), {
		credentials: "include",
		...options,
	});

	let payload = {};
	try {
		payload = await response.json();
	} catch {
		payload = {};
	}

	return { response, payload };
}

export function assertOk(response, payload, fallbackMessage) {
	if (!response.ok) {
		const message = payload?.error || fallbackMessage;
		const detail = response.status ? `${message} (${response.status})` : message;
		throw new Error(detail);
	}

	return payload;
}


export async function fetchAvailability(startDate, endDate, duration = 60) {
	const currentUserId = useUserStore.getState().session?.profile?.id;
	if (!currentUserId) {
		throw new Error("No signed-in user found for availability lookup.");
	}
	if (!startDate || !endDate) {
		throw new Error("start_date and end_date are required for availability lookup.");
	}

	const { response, payload } = await requestJson(`/availability/admin/index/${String(currentUserId)}`, {
		method: "POST",
	});
	return assertOk(response, payload, "Failed to fetch availability.");
}


export async function saveAvailability(dayRows) {
  const currentUserId = useUserStore.getState().session?.profile?.id;

  if (!currentUserId) {
    throw new Error("No signed-in user found for saving availability.");
  }

	const days = dayRows.map((day) => ({
		day_of_week: Number(day.day_of_week),
		windows: (day.windows ?? []).map((window) => ({
			start_time: window.start_time,
			end_time: window.end_time,
		})),
	}));

  const { response, payload } = await requestJson("/availability", {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      user_id: String(currentUserId),
      days,
    }),
  });

  return assertOk(response, payload, "Failed to save availability.");
}


export async function InsertAvailabilityException(startAt, endAt, reason, userIdOverride) {
	const currentUserId = userIdOverride ?? useUserStore.getState().session?.profile?.id;
	if (!currentUserId) {
		throw new Error("No signed-in user found for inserting availability exception.");
	}

	const { response, payload } = await requestJson("/availability/exception", {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			user_id: String(currentUserId),
			start_at: startAt,
			end_at: endAt,
			reason,
		}),
	});
	return assertOk(response, payload, "Failed to insert availability exception.");
}


export async function fetchAvailabilityExceptions(userIdOverride) {
	const currentUserId = userIdOverride ?? useUserStore.getState().session?.profile?.id;
	if (!currentUserId) {
		throw new Error("No signed-in user found for fetching availability exceptions.");
	}

	const { response, payload } = await requestJson(`/availability/exceptions/${String(currentUserId)}`, {
		method: "GET",
	});
	return assertOk(response, payload, "Failed to fetch availability exceptions.");
}
